import { Card } from "@amzn/stencil-react-components/card";
import React, { FC } from "react";
import { AddressEditor } from "./address-editor";
import type { AddressEditorState } from "./address-editor.types";

export interface ShipPanelProps {
  editor: AddressEditorState;
}

export const ShipPanel: FC<ShipPanelProps> = ({ editor }) => (
  <Card width="100%" data-testid="ship-panel">
    <AddressEditor editor={editor} />
  </Card>
);
